export class AbstractStrategy {
    constructor() {}

    static log(x)   { console.log(x); return x; }

    static getters()                { return this.store().getters; }
    static dispatch(name, payload)  { this.store().dispatch(name, payload); }


    static store()  { return window.$_store; }
    static ebus()   { return window.$_ebus; }
    static http()   { return window.$_http; }
    // static router() { return window.$_router; }
}

export default AbstractStrategy;